export const clearPhoneMask = phone =>
  phone.replace(' ', '').replace('-', '').replace('(', '').replace(')', '')

export const trimString = str => (factor = 0) => str.charAt(factor)
